var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('campaign-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var campaign = ref.campaign;
var createProposal = ref.createProposal;
var incompleteProposal = ref.incompleteProposal;
var isLoading = ref.isLoading;
var isCreatingProposal = ref.isCreatingProposal;
return [_c('campaign-view',{attrs:{"is-loading":isLoading,"campaign":campaign,"incomplete-proposal":incompleteProposal,"is-creating-proposal":isCreatingProposal},on:{"create-proposal":createProposal}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }